import { render } from "./ContainersForm.vue?vue&type=template&id=557bcc7d"
import script from "./ContainersForm.vue?vue&type=script&lang=js"
export * from "./ContainersForm.vue?vue&type=script&lang=js"
script.render = render

export default script